import React from "react";
import styled from "styled-components";

const MyInput = styled.div`
  margin-bottom: 25px;
  @media screen and (max-width: 575px) {
    margin-bottom: 20px;
  }
  > label {
    display: block;
    width: 100%;
    margin-bottom: 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #f2f2f2;
    @media screen and (max-width: 575px) {
      font-size: 13px;
    }
    > .impStar {
      color: red;
    }
  }
  .input_icon {
    position: relative;
    > .icon {
      height: 50px;
      width: 50px;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 575px) {
        height: 40px;
        width: 40px;
        font-size: 13px;
      }
      > svg {
        color: #a9b5bb;
        z-index: 1;
        position: absolute;
        width: 40%;
        height: 40%;
      }
    }
  }
  .input_text {
    display: block;
    width: 100%;
    resize: none;
    background: linear-gradient(
      115.85deg,
      rgba(255, 255, 255, 0.4) -185.19%,
      rgba(255, 255, 255, 0) 129.07%
    );
    backdrop-filter: blur(21px);
    border-radius: 4px;
    border: none;
    outline: none;
    box-sizing: border-box;
    padding: 10px;
    color: #a9b5bb;
    font-size: 14px;
    @media screen and (max-width: 575px) {
      font-size: 13px;
    }
  }

  .wordLimit {
    position: absolute;
    right: 0;
    bottom: 0;
    background: red;
    padding: 3px;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 12px;
    color: #333;
  }
`;

const CustomTextarea = ({
  icon,
  label,
  rows = "5",
  type,
  onChange,
  placeholder,
  value,
  readOnly,
  name,
  fullWidth,
  textLength,
  textCount,
  borderColor,
  impStar,
}) => {
  return (
    <MyInput className="myInput" style={{ width: fullWidth ? "100%" : "" }}>
      {label && (
        <label>
          {label} {impStar && <abbr className="impStar">{impStar}</abbr>}
        </label>
      )}
      <div className="input_icon">
        {icon && <span className="icon">{icon}</span>}
        <textarea
          className="input_text"
          rows={rows}
          value={value}
          readOnly={readOnly}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          style={{ paddingLeft: icon && "50px",  border: borderColor && `1px solid ${borderColor}` }}
        />
        {textLength && (
          <p
            className="wordLimit"
            style={{
              background:
                value?.length > textLength || value?.length < 125
                  ? "red"
                  : "white",
              color:
                value?.length > textLength || value?.length < 125
                  ? "white"
                  : "",
            }}
          >
            {value?.length}/{textLength}
          </p>
        )}
        {textCount && (
          <p
            className="wordLimit"
            style={{
              background:
                value?.length > textCount || value?.length < 150
                  ? "red"
                  : "white",
              color:
                value?.length > textCount || value?.length < 150 ? "white" : "",
            }}
          >
            {value?.length}/{textCount}
          </p>
        )}
      </div>
    </MyInput>
  );
};

export default CustomTextarea;
